import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import Url from '@core/scripts/helper/url';

export default function acquireWishlistState(styleId, itemId) {
    acquireWishlistState.count = acquireWishlistState.count ? acquireWishlistState.count + 1 : 1;

    if (!acquireWishlistState.wishlistPromise) {
        const url = Url.toAbsolute(`list/wishlist/variants/`);
        acquireWishlistState.wishlistPromise = fetchWithCSRF(url, {method: "GET"}).then(
            (response) => response.text()
        );
    }

    return acquireWishlistState.wishlistPromise.then((wishlistItems) => {
        setTimeout(() => {
            acquireWishlistState.count--;
            if (acquireWishlistState.count === 0) {
                acquireWishlistState.wishlistPromise = undefined;
            }
        }, 300);

        return JSON.parse(wishlistItems)
            .some(item =>
                item.digistyleId === Number(styleId) &&
                item.itemId === Number(itemId)
            );
    });
}

export function acquireWishlistStateByDigistyleId(styleId) {
    acquireWishlistState.count = acquireWishlistState.count ? acquireWishlistState.count + 1 : 1;

    if (!acquireWishlistState.wishlistPromise) {
        const url = Url.toAbsolute(`list/wishlist/digistyleids/`);
        acquireWishlistState.wishlistPromise = fetchWithCSRF(url, {method: "GET"}).then(
            (response) => response.text()
        );
    }

    return acquireWishlistState.wishlistPromise.then((wishlistIds) => {
        setTimeout(() => {
            acquireWishlistState.count--;
            if (acquireWishlistState.count === 0) {
                acquireWishlistState.wishlistPromise = undefined;
            }
        }, 300);
        return wishlistIds.includes(styleId);
    });
}